import { render, staticRenderFns } from "./UserHelpModal.vue?vue&type=template&id=39632d2f&scoped=true&"
import script from "./UserHelpModal.vue?vue&type=script&lang=ts&"
export * from "./UserHelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./UserHelpModal.vue?vue&type=style&index=0&id=39632d2f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39632d2f",
  null
  
)

export default component.exports